import * as z from 'zod';

// Types
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { TextZod } from '@/components/molecules/Text/TextType';

const ActivitiesZod = z.object({
  __component: z.literal('block.activities'),
  id: z.number(),
  title: TitleZod,
  darkerBackgroundOnHover: z.boolean(),
  activities: z.array(TextZod).nullable(),
  waveWrapper: WaveWrapperZod.nullable(),
});

export { ActivitiesZod };
export type ActivitiesType = z.infer<typeof ActivitiesZod>;
